import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const BuyDexmoji = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Buy Dexmoji - Cheapest Dexscreener Reaction Bot | Dexreaction</title>
        <meta name="description" content="Buy Dexmoji at the lowest prices! Get all Dexscreener emojis: Rocket 🚀, Fire 🔥, Star ⭐, Poop 💩, Flag 🚩. Starting $0.05/reaction. Instant delivery via Telegram bot. 10% bonus included!" />
        <meta name="keywords" content="buy dexmoji, dexmoji, dexmoji bot, buy dexscreener reaction, buy dexscreener rockets, buy dexscreener fire, buy dexscreener poop, dexreactions, dexscreener emoji, dexscreener reactions, buy dexscreener emoji, telegram dexmoji bot, dexmoji reactions, cheapest dexmoji, dexscreener emoji reactions, cheap dexscreener reactions" />
        <link rel="canonical" href="https://dexreaction.com/buy-dexmoji" />
        <meta property="og:title" content="Buy Dexmoji - Cheapest Dexscreener Reaction Service | Dexreaction" />
        <meta property="og:description" content="Buy Dexmoji from $0.05! All emojis available. Telegram bot & web panel. Instant delivery!" />
        <meta property="og:image" content="https://dexreaction.com/og-image.png" />
        <meta property="og:image" content="https://dexreaction.com/logo-light.png" />
        <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-blue-900/20 to-slate-900">
        {/* Header */}
        <nav className="fixed top-0 w-full bg-slate-900/80 backdrop-blur-md border-b border-blue-500/20 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                <img src="/logo-light.png" alt="Dexreaction" className="h-8" />
              </div>
              <button
                onClick={() => navigate('/')}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors"
              >
                Get Started
              </button>
            </div>
          </div>
        </nav>

        {/* Hero Section - Different Layout */}
        <section className="pt-32 pb-20 px-4">
          <div className="max-w-7xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <div className="inline-block bg-blue-500/20 text-blue-300 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                  Premium Dexmoji Service
                </div>
                <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-400 bg-clip-text text-transparent">
                  Buy Dexmoji
                </h1>
                <p className="text-xl text-gray-300 mb-6">
                  Add authentic emoji reactions to your DexScreener token listing. Build social proof and attract more investors with genuine Dexmoji.
                </p>
                <ul className="space-y-3 mb-8">
                  {[
                    '🚀 5 Different Emoji Types',
                    '⚡ 500 Reactions Per 10min',
                    '🎁 20% Bonus Reactions Free',
                    '💰 Starting at $0.05/reaction',
                    '🔒 Secure Solana Payments'
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-center text-gray-300">
                      <span className="mr-3">{item}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => navigate('/')}
                  className="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105"
                >
                  Buy Dexmoji Now
                </button>
              </div>
              <div className="bg-slate-800/50 border border-blue-500/20 rounded-2xl p-8">
                <h3 className="text-2xl font-bold mb-6 text-center">Available Dexmoji</h3>
                <div className="grid grid-cols-2 gap-4">
                  {[
                    { emoji: '🚀', name: 'Rocket', color: 'from-orange-500 to-yellow-500' },
                    { emoji: '🔥', name: 'Fire', color: 'from-red-500 to-orange-500' },
                    { emoji: '💩', name: 'Poop', color: 'from-amber-700 to-yellow-600' },
                    { emoji: '🚩', name: 'Red Flag', color: 'from-red-600 to-pink-600' },
                    { emoji: '⭐', name: 'Favorite', color: 'from-yellow-400 to-yellow-500' }
                  ].map((item) => (
                    <div key={item.name} className={`bg-gradient-to-br ${item.color} p-1 rounded-xl`}>
                      <div className="bg-slate-900 rounded-lg p-4 text-center h-full">
                        <div className="text-4xl mb-2">{item.emoji}</div>
                        <div className="text-sm font-semibold">{item.name}</div>
                      </div>
                    </div>
                  ))}
                  <div className="col-span-2 bg-gradient-to-r from-blue-600 to-cyan-600 p-1 rounded-xl">
                    <div className="bg-slate-900 rounded-lg p-4 text-center">
                      <div className="text-lg font-bold">All Available Now!</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* What is Dexmoji */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-6">
              What is Dexmoji?
            </h2>
            <p className="text-xl text-gray-300 text-center mb-12 max-w-3xl mx-auto">
              Dexmoji are emoji reactions on DexScreener that help tokens stand out and build community engagement. Each emoji conveys different sentiment and attracts attention to your token listing.
            </p>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-6xl mb-4">🎯</div>
                <h3 className="text-xl font-bold mb-3">Targeted Expression</h3>
                <p className="text-gray-400">
                  Each Dexmoji conveys specific sentiment - from bullish 🚀 to warning signals 🚩
                </p>
              </div>
              <div className="text-center">
                <div className="text-6xl mb-4">👥</div>
                <h3 className="text-xl font-bold mb-3">Community Signal</h3>
                <p className="text-gray-400">
                  High reaction counts show active community interest and social validation
                </p>
              </div>
              <div className="text-center">
                <div className="text-6xl mb-4">📊</div>
                <h3 className="text-xl font-bold mb-3">Ranking Boost</h3>
                <p className="text-gray-400">
                  More reactions improve your token's visibility in DexScreener trending lists
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Dexmoji Types Detail */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Choose Your Dexmoji Type
            </h2>
            <div className="space-y-6">
              {[
                {
                  emoji: '🚀',
                  name: 'Rocket Dexmoji',
                  desc: 'The most popular choice for bullish tokens. Signals strong upward momentum and community confidence.',
                  useCase: 'Perfect for: New launches, trending tokens, bullish announcements'
                },
                {
                  emoji: '🔥',
                  name: 'Fire Dexmoji',
                  desc: 'Shows your token is hot and attracting attention. Great for viral moments and peak trading activity.',
                  useCase: 'Perfect for: High volume days, viral campaigns, trending moments'
                },
                {
                  emoji: '⭐',
                  name: 'Favorite Dexmoji',
                  desc: 'Expresses genuine community love and support. Builds long-term holder confidence.',
                  useCase: 'Perfect for: Community tokens, established projects, fan favorites'
                },
                {
                  emoji: '💩',
                  name: 'Poop Dexmoji',
                  desc: 'Can be used ironically or for meme tokens. Sometimes used for bearish sentiment.',
                  useCase: 'Perfect for: Meme tokens, ironic marketing, controversial projects'
                },
                {
                  emoji: '🚩',
                  name: 'Red Flag Dexmoji',
                  desc: 'Warning signal for community concerns. Less common but has specific use cases.',
                  useCase: 'Perfect for: Risk awareness, community warnings'
                }
              ].map((item, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-blue-500/20 rounded-xl p-6 hover:border-blue-500/50 transition-all">
                  <div className="flex flex-col md:flex-row gap-6 items-start">
                    <div className="text-6xl flex-shrink-0">{item.emoji}</div>
                    <div className="flex-grow">
                      <h3 className="text-2xl font-bold mb-2">{item.name}</h3>
                      <p className="text-gray-300 mb-3">{item.desc}</p>
                      <p className="text-sm text-blue-400">{item.useCase}</p>
                    </div>
                    <button
                      onClick={() => navigate('/')}
                      className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap"
                    >
                      Buy Now
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing Table */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Simple Dexmoji Pricing
            </h2>
            <div className="bg-slate-800/50 border border-blue-500/20 rounded-xl overflow-hidden">
              <table className="w-full">
                <thead className="bg-blue-600/20">
                  <tr>
                    <th className="px-6 py-4 text-left">Reactions</th>
                    <th className="px-6 py-4 text-left">Price</th>
                    <th className="px-6 py-4 text-left">With 20% Bonus</th>
                    <th className="px-6 py-4 text-left">Per Reaction</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-blue-500/10">
                  {[
                    { qty: 500, price: 25, total: 600 },
                    { qty: 1000, price: 50, total: 1200 },
                    { qty: 1500, price: 75, total: 1800 },
                    { qty: 2000, price: 100, total: 2400 }
                  ].map((pkg) => (
                    <tr key={pkg.qty} className="hover:bg-blue-500/5 transition-colors">
                      <td className="px-6 py-4 font-semibold">{pkg.qty}</td>
                      <td className="px-6 py-4 text-blue-400 font-bold">${pkg.price}</td>
                      <td className="px-6 py-4">
                        <span className="text-green-400 font-semibold">{pkg.total} total</span>
                        <span className="text-xs text-gray-400 ml-2">(+{pkg.total - pkg.qty} free)</span>
                      </td>
                      <td className="px-6 py-4 text-gray-400">$0.05</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="text-center text-gray-400 mt-6">
              💡 Need more? Enter custom quantity up to 10,000 reactions
            </p>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Why Buy Dexmoji from Dexreaction?
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              {[
                { icon: '⚡', title: 'Instant Start', desc: 'Your Dexmoji order begins delivery immediately after payment verification' },
                { icon: '🔒', title: 'Safe & Secure', desc: 'All reactions delivered through authentic accounts, no bot detection risk' },
                { icon: '💎', title: 'Premium Quality', desc: 'Real engagement from genuine accounts that look natural' },
                { icon: '🎁', title: 'Bonus Reactions', desc: 'Every order includes 20% extra Dexmoji completely free' },
                { icon: '24/7', title: 'Always Available', desc: '24/7 automated service with instant order processing' },
                { icon: '💰', title: 'Best Prices', desc: 'Most competitive rates in the market at $0.05 per reaction' }
              ].map((item, idx) => (
                <div key={idx} className="flex gap-4 bg-slate-800/50 border border-blue-500/20 rounded-xl p-6">
                  <div className="text-3xl flex-shrink-0">{item.icon}</div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                    <p className="text-gray-400">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 px-4 bg-gradient-to-r from-blue-900/30 to-cyan-900/30">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Start Adding Dexmoji Today
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Join successful token projects using Dexreaction Dexmoji
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/')}
                className="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white px-12 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105"
              >
                Buy Dexmoji Now
              </button>
              <button
                onClick={() => navigate('/')}
                className="bg-slate-800 hover:bg-slate-700 text-white px-12 py-4 rounded-lg font-bold text-xl transition-all border border-blue-500/30"
              >
                View All Options
              </button>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-slate-900 border-t border-blue-500/20 py-8 px-4">
          <div className="max-w-6xl mx-auto text-center text-gray-400">
            <p>&copy; 2025 Dexreaction. All rights reserved.</p>
            <div className="mt-4 space-x-4">
              <button onClick={() => navigate('/terms')} className="hover:text-blue-400 transition-colors">Terms</button>
              <button onClick={() => navigate('/privacy')} className="hover:text-blue-400 transition-colors">Privacy</button>
              <button onClick={() => navigate('/')} className="hover:text-blue-400 transition-colors">Contact</button>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default BuyDexmoji;
